import {
  DocumentType,
  SearchDocumentAttachment
} from '../redux/api/documentAttachments/documentAttachment.model';
import DateUtils from './dateUtils';

class AttachmentUtils {
  static getDocumentTypeLabel = (documentType: DocumentType): string => {
    switch (documentType) {
      case DocumentType.proofOfDelivery:
        return 'Proof of Delivery';
      case DocumentType.rateConfirmation:
        return 'Rate Confirmation';
      case DocumentType.billOfLading:
        return 'Bill of Lading';
      case DocumentType.lumper:
        return 'Lumper';
      case DocumentType.receipt:
        return 'Receipt';
      case DocumentType.invoice:
        return 'Invoice';
      case DocumentType.other:
        return 'Other';
      case DocumentType.empty:
        return 'Empty';
      case DocumentType.tripManifest:
        return 'Trip Manifest';
      case DocumentType.photo:
        return 'Photo';
      case DocumentType.permit:
        return 'Permit';
      case DocumentType.driverInstructions:
        return 'Driver Instructions';
      default:
        return '';
    }
  };

  static getDocumentType = (attachment: SearchDocumentAttachment): DocumentType | undefined => {
    if (!attachment.document_type) return undefined;

    return attachment.document_type;
  };

  static getTripIdOrderIdOrExpenseId = (
    attachment: SearchDocumentAttachment,
    type: 'TRIP' | 'ORDER' | 'OTHER_EXPENSE'
  ):
    | {
        id: string;
        readable_value: string;
        customer_order_number?: string;
        customer_name?: string;
        date_from?: string;
        date_to?: string;
      }
    | undefined
    | null => {
    if (attachment.entities_associated.length < 1) return undefined;

    for (const entity of attachment.entities_associated) {
      if (entity.entity_type === type) {
        switch (type) {
          case 'TRIP':
            return entity.trip
              ? { id: entity.trip?.id, readable_value: String(entity.trip?.readable_id) }
              : null;
          case 'ORDER':
            return entity.order
              ? {
                  id: entity.order?.id,
                  readable_value: String(entity.order?.readable_id),
                  customer_order_number: entity.order?.customer_order_number,
                  customer_name: entity.order?.customer?.name
                }
              : null;
          case 'OTHER_EXPENSE':
            return entity.other_expense
              ? {
                  id: entity.other_expense?.id,
                  readable_value: `${entity.other_expense?.name} | ${DateUtils.getShortDottedDate(
                    new Date(entity.other_expense?.date_from)
                  )} ${
                    entity.other_expense?.date_to
                      ? `- ${DateUtils.getShortDottedDate(new Date(entity.other_expense?.date_to))}`
                      : ''
                  }`
                }
              : null;
        }
      }
    }

    return undefined;
  };

  static getDriverId = (
    attachment: SearchDocumentAttachment
  ): { id: string; name: string } | undefined | null => {
    if (!attachment.driver) return undefined;

    return {
      id: attachment.driver.id,
      name: `${attachment.driver.first_name} ${attachment.driver.last_name}`
    };
  };

  static getEquipmentId = (
    attachment: SearchDocumentAttachment
  ): { id: string; name: string } | undefined | null => {
    if (!attachment.equipment) return undefined;

    return {
      id: attachment.equipment.id,
      name: attachment.equipment.name
    };
  };

  static getVisibility = (
    attachment: SearchDocumentAttachment
  ): 'visible' | 'hidden' | undefined => {
    return attachment.visibility ? 'visible' : 'hidden';
  };
}

export default AttachmentUtils;
